import { AnyAction, Dispatch } from 'redux';
import update from 'immutability-helper';

import { loadBusinessTypes as doLoadBusinessTypes } from 'src/common/services/businessTypes';
import { TechnicalType } from '../interfaces/TechnicalType';

const START_LOAD = 'common/businessTypes/START_LOAD';
const COMPLETE_LOAD = 'common/businessTypes/COMPLETE_LOAD';
const FAIL_LOAD = 'common/businessTypes/FAIL_LOAD';
const RESET = 'common/businessTypes/RESET';

type State = {
  businessTypes: TechnicalType[];
  isLoading: boolean;
};

const initialState: State = {
  businessTypes: [],
  isLoading: false,
};

export const reducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case START_LOAD:
      return update(state, {
        $merge: {
          isLoading: true,
        },
      });

    case COMPLETE_LOAD:
      return update(state, {
        $merge: {
          isLoading: false,
          businessTypes: action.businessTypes,
        },
      });

    case FAIL_LOAD:
      return update(state, {
        $merge: {
          isLoading: false,
          businessTypes: [],
        },
      });

    case RESET:
      return update(state, {
        $merge: initialState,
      });

    default:
      return state;
  }
};

const startLoad = () => ({
  type: START_LOAD,
});

const completeLoad = (businessTypes: TechnicalType[]) => ({
  type: COMPLETE_LOAD,
  businessTypes,
});

const failLoad = () => ({
  type: FAIL_LOAD,
});

export const loadBusinessTypes = () => (dispatch: Dispatch) => {
  dispatch(startLoad());
  const loadBusinessTypesPromise = doLoadBusinessTypes();
  loadBusinessTypesPromise
    .then(businessTypes => dispatch(completeLoad(businessTypes)))
    .catch(() => dispatch(failLoad()));
  return loadBusinessTypesPromise;
};

export const resetBusinessTypes = () => ({
  type: RESET,
});
